/* tslint:disable */
/* eslint-disable */
/* @relayHash 1c009d2208f0941a849645e964b27f3b */

import { ConcreteRequest } from "relay-runtime";
export type MarkCommentsAsSeenInput = {
    clientMutationId: string;
    storyID: string;
    commentIDs: Array<string>;
};
export type MarkCommentsAsSeenMutationVariables = {
    input: MarkCommentsAsSeenInput;
};
export type MarkCommentsAsSeenMutationResponse = {
    readonly markCommentsAsSeen: {
        readonly comments: ReadonlyArray<{
            readonly id: string;
            readonly seen: boolean | null;
        }>;
        readonly clientMutationId: string;
    };
};
export type MarkCommentsAsSeenMutation = {
    readonly response: MarkCommentsAsSeenMutationResponse;
    readonly variables: MarkCommentsAsSeenMutationVariables;
};



/*
mutation MarkCommentsAsSeenMutation(
  $input: MarkCommentsAsSeenInput!
) {
  markCommentsAsSeen(input: $input) {
    comments {
      id
      seen
    }
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any)
    ], v1 = [
        ({
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "MarkCommentsAsSeenPayload",
            "kind": "LinkedField",
            "name": "markCommentsAsSeen",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "seen",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientMutationId",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any)
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "MarkCommentsAsSeenMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "MarkCommentsAsSeenMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "id": "1c009d2208f0941a849645e964b27f3b",
            "metadata": {},
            "name": "MarkCommentsAsSeenMutation",
            "operationKind": "mutation",
            "text": null
        }
    } as any;
})();
(node as any).hash = '0274c9d31d44c3fb211b37b37bd2b47d';
export default node;
